"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "parcines": {
    "0dc5b401": [{
      "hkey": "0c22666c",
      "slug": "parcines",
      "name": "Parcines",
      "primary": true,
      "skipSearch": false
    }],
    "montesole": [{
      "hkey": "0c22666c",
      "slug": "parcines",
      "name": "Parcines",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "52352cd7": [{
      "hkey": "0c22666c",
      "slug": "parcines",
      "name": "Parcines",
      "primary": true,
      "skipSearch": false
    }],
    "quadrato": [{
      "hkey": "0c22666c",
      "slug": "parcines",
      "name": "Parcines",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "672bc37c": [{
      "hkey": "0c22666c",
      "slug": "parcines",
      "name": "Parcines",
      "primary": true,
      "skipSearch": false
    }],
    "vallettina": [{
      "hkey": "0c22666c",
      "slug": "parcines",
      "name": "Parcines",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;